import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExposureIcon(props: IconProps) {
    return <Icon {...props} iconKey={"exposure"}/>
}
